/* eslint-disable react/jsx-no-useless-fragment */
import { BreadCrumb } from "ui/bread-crumbs";
import { PATHS } from "routes/paths";
import CreateBulkTickets from "components/tickets/bulk/bulk-creation";
import SiteReplenishmentTickets from "components/tickets/bulk/bulk-site-replenishment";
import CloseBulkCashTickets from "components/tickets/bulk/bulk-cash-closing";
import CloseBulkTickets from "components/tickets/bulk/bulk-closing";
import CreateBulkVoiceOfStaffTickets from "components/tickets/bulk/voice-of-staff";
import { useUser } from "hooks/use-user";

export default function BulkOperations() {
  const user = useUser();
  const isCCSupervisor = user.Roles.includes("CC Supervisor");
  return (
    <>
      <div className="form-container">
        <BreadCrumb
          items={[
            { to: PATHS.openTickets, text: `Tickets` },
            {
              text: `Create Tickets`,
            },
          ]}
        />
        <div className="flex flex-col gap-[16px]">
          <div className="flex flex-row gap-[16px]">
            <div className="flex" style={{ width: "calc( 50% - 8px )" }}>
              <CreateBulkTickets />
            </div>
            <div className="flex" style={{ width: "calc( 50% - 8px )" }}>
              <CloseBulkTickets />
            </div>
          </div>
          <div className="flex flex-row gap-[16px]">
            <div className="flex" style={{ width: "calc( 50% - 8px )" }}>
              <SiteReplenishmentTickets />
            </div>
            <div className="flex" style={{ width: "calc( 50% - 8px )" }}>
              <CloseBulkCashTickets />
            </div>
          </div>
          {isCCSupervisor ? (
            <div className="flex flex-row gap-[16px]">
              <div className="flex" style={{ width: "calc( 50% - 8px )" }}>
                <CreateBulkVoiceOfStaffTickets />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
